var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 589.096,
    height: 382.233,
    viewBox: "0 0 589.096 382.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "files",
    transform: "translate(-35.007 -38.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(47.411 38.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4186",
    "data-name": "Group 4186",
    transform: "translate(281.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4184",
    "data-name": "Group 4184",
    transform: "translate(50.582 7.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M464.681,73.343l10.166,26.163-6.32-.029L463.462,83.4Z",
    transform: "translate(-426.471 -49.168)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4183",
    "data-name": "Group 4183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4182",
    "data-name": "Group 4182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M425.362,46.322l-3.495,50.131,36.078.758,4.059-50.889Z",
    transform: "translate(-421.868 -46.322)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M429.494,50.805l-2.909,41.727L453.4,93.8l3.747-43.239Z",
    transform: "translate(-422.39 -46.768)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M436.2,57.43l-2.176,29.331h14.795l2.61-29.331Z",
    transform: "translate(-423.213 -47.492)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4185",
    "data-name": "Group 4185",
    transform: "translate(14.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M385.786,99.752v-25.1h18.27V99.732Z",
    transform: "translate(-381.585 -42.292)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M396.732,70.843s4.407-32.406,3.173-32.361-4.335,29.546-4.335,29.546-.13-24.433-1.291-24.3,0,25.861,0,25.861S392.292,48.7,391.219,49.2s.461,21.639.461,21.639h5.053",
    transform: "translate(-382.143 -38.482)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M393.732,71.638s1.527-16.152,2.031-15.047,0,9.616,0,9.616,4.23-20.872,5.338-20.163-4.33,22.655-4.33,22.655,4.129-12.529,5.035-11.208-3.425,13.073-3.425,13.073,4.431-8.308,4.734-7.193S401,71.638,401,71.638Z",
    transform: "translate(-382.464 -39.276)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M389.727,72.56s-9.77-19.293-8.561-18.694,7.453,13.06,7.453,13.06-4.133-12.029-3.225-12.4,5.44,13.512,5.44,13.512l1.017,4.52Z",
    transform: "translate(-381.062 -40.101)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M394.252,74.69l.462,25.1h-8.687l-.167-25.183Z",
    transform: "translate(-381.593 -42.287)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M385.78,76.847l8.414.141,9.836-.141.309-2.4h-18.8Z",
    transform: "translate(-381.557 -42.27)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 127.914,
    height: 6.627,
    transform: "translate(0 56.761)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4219",
    "data-name": "Group 4219",
    transform: "translate(0 168.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4218",
    "data-name": "Group 4218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4212",
    "data-name": "Group 4212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4187",
    "data-name": "Group 4187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M129.532,226.262l1.845,209.329H48.954V229.116Z",
    transform: "translate(-48.954 -226.262)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4188",
    "data-name": "Group 4188",
    transform: "translate(0 1.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M85.128,228.02l.729,207.756h-36.9V229.3Z",
    transform: "translate(-48.954 -228.02)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4193",
    "data-name": "Group 4193",
    transform: "translate(38.945 2.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4189",
    "data-name": "Group 4189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M131.788,229.148V258.49H92.746V230.535Z",
    transform: "translate(-92.746 -229.148)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4192",
    "data-name": "Group 4192",
    transform: "translate(13.246 7.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4190",
    "data-name": "Group 4190",
    transform: "translate(0.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M120.026,238.124v4.334H108.081V237.73Z",
    transform: "translate(-108.081 -237.73)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4191",
    "data-name": "Group 4191",
    transform: "translate(0 8.372)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 12.336,
    height: 1.773,
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4198",
    "data-name": "Group 4198",
    transform: "translate(38.945 105.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4194",
    "data-name": "Group 4194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M131.788,344.074v29.342H92.746V345.461Z",
    transform: "translate(-92.746 -344.074)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4197",
    "data-name": "Group 4197",
    transform: "translate(13.246 7.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4195",
    "data-name": "Group 4195",
    transform: "translate(0.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M120.026,353.05v4.334H108.081v-4.728Z",
    transform: "translate(-108.081 -352.656)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4196",
    "data-name": "Group 4196",
    transform: "translate(0 8.372)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 12.336,
    height: 1.773,
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4203",
    "data-name": "Group 4203",
    transform: "translate(38.945 35.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4199",
    "data-name": "Group 4199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M131.788,266.119v29.342H92.746V267.506Z",
    transform: "translate(-92.746 -266.119)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4202",
    "data-name": "Group 4202",
    transform: "translate(13.246 7.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4200",
    "data-name": "Group 4200",
    transform: "translate(0.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M120.026,275.1v4.334H108.081V274.7Z",
    transform: "translate(-108.081 -274.702)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4201",
    "data-name": "Group 4201",
    transform: "translate(0 8.372)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 12.336,
    height: 1.773,
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4207",
    "data-name": "Group 4207",
    transform: "translate(38.945 138.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4204",
    "data-name": "Group 4204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M131.788,381.038V410.38H92.746V382.425Z",
    transform: "translate(-92.746 -381.038)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4205",
    "data-name": "Group 4205",
    transform: "translate(13.638 7.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M120.026,390.014v4.334H108.081V389.62Z",
    transform: "translate(-108.081 -389.62)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4206",
    "data-name": "Group 4206",
    transform: "translate(13.246 16.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 12.336,
    height: 1.773,
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4211",
    "data-name": "Group 4211",
    transform: "translate(39.366 171.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4208",
    "data-name": "Group 4208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M132.261,418v29.342H93.219V419.388Z",
    transform: "translate(-93.219 -418.002)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    transform: "translate(13.638 7.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M120.5,426.978v4.334H108.554v-4.728Z",
    transform: "translate(-108.554 -426.584)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4210",
    "data-name": "Group 4210",
    transform: "translate(13.246 16.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 12.336,
    height: 1.773,
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4217",
    "data-name": "Group 4217",
    transform: "translate(39.454 70.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4216",
    "data-name": "Group 4216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4213",
    "data-name": "Group 4213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 39.042,
    height: 29.342,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4214",
    "data-name": "Group 4214",
    transform: "translate(14.091 12.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M120.391,320.125V324.2H109.163v-4.444Z",
    transform: "translate(-109.163 -319.755)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4215",
    "data-name": "Group 4215",
    transform: "translate(13.723 20.723)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 11.596,
    height: 1.667,
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4226",
    "data-name": "Group 4226",
    transform: "translate(317.93 344.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4225",
    "data-name": "Group 4225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4220",
    "data-name": "Group 4220",
    transform: "translate(3.28 7.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M410.14,431.69v25.577h78.185V431.69Z",
    transform: "translate(-410.14 -431.69)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4221",
    "data-name": "Group 4221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M406.451,423.7v7.151h84.2V423.7h-84.2Z",
    transform: "translate(-406.451 -423.697)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4222",
    "data-name": "Group 4222",
    transform: "translate(40.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M453.586,456.424h39.366V430.848h2.734V423.7h-43.74v6.489Z",
    transform: "translate(-451.946 -423.697)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4223",
    "data-name": "Group 4223",
    transform: "translate(14.215 11.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 15.856,
    height: 3.85,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4224",
    "data-name": "Group 4224",
    transform: "translate(12.175 19.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 20.36,
    height: 8.13,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4233",
    "data-name": "Group 4233",
    transform: "translate(418.943 311.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4232",
    "data-name": "Group 4232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4227",
    "data-name": "Group 4227",
    transform: "translate(3.28 7.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M523.725,395.109v25.577H601.91V395.109Z",
    transform: "translate(-523.725 -395.109)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4228",
    "data-name": "Group 4228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M520.036,387.117v7.151h84.2v-7.151h-84.2Z",
    transform: "translate(-520.036 -387.117)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4229",
    "data-name": "Group 4229",
    transform: "translate(40.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M567.171,419.844h39.366V394.268h2.734v-7.151h-43.74v6.489Z",
    transform: "translate(-565.531 -387.117)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4230",
    "data-name": "Group 4230",
    transform: "translate(14.215 11.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 15.856,
    height: 3.85,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4231",
    "data-name": "Group 4231",
    transform: "translate(12.175 19.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 20.36,
    height: 8.13,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4240",
    "data-name": "Group 4240",
    transform: "translate(415.199 344.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4239",
    "data-name": "Group 4239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4234",
    "data-name": "Group 4234",
    transform: "translate(3.28 7.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M519.516,431.69v25.577H597.7V431.69Z",
    transform: "translate(-519.516 -431.69)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4235",
    "data-name": "Group 4235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M515.827,423.7v7.151h84.2V423.7h-84.2Z",
    transform: "translate(-515.827 -423.697)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4236",
    "data-name": "Group 4236",
    transform: "translate(40.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M562.962,456.424h39.366V430.848h2.734V423.7h-43.74v6.489Z",
    transform: "translate(-561.321 -423.697)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4237",
    "data-name": "Group 4237",
    transform: "translate(14.215 11.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 15.856,
    height: 3.85,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4238",
    "data-name": "Group 4238",
    transform: "translate(12.175 19.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 20.36,
    height: 8.13,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(35.007 415.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4274",
    "data-name": "Group 4274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M624.1,460.22c0,.128-131.884.233-294.534.233-162.707,0-294.563-.1-294.563-.233s131.856-.234,294.563-.234C492.219,459.986,624.1,460.091,624.1,460.22Z",
    transform: "translate(-35.007 -459.986)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Folder",
    transform: "translate(204.033 125.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4300",
    "data-name": "Group 4300",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4275",
    "data-name": "Group 4275",
    transform: "translate(6.401 41.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M232.279,190.492l6.279,107.71a7.249,7.249,0,0,0,7.2,6.848l192.71.591a7.253,7.253,0,0,0,7.252-7.252l.254-83.862a7.251,7.251,0,0,0-7.255-7.3l-118.517.4a7.207,7.207,0,0,1-5.114-2.108L294.55,185.053a7.211,7.211,0,0,0-5.067-2.108l-49.963-.153A7.255,7.255,0,0,0,232.279,190.492Z",
    transform: "translate(-232.267 -182.792)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M232.279,190.492l6.279,107.71a7.249,7.249,0,0,0,7.2,6.848l192.71.591a7.253,7.253,0,0,0,7.252-7.252l.254-83.862a7.251,7.251,0,0,0-7.255-7.3l-118.517.4a7.207,7.207,0,0,1-5.114-2.108L294.55,185.053a7.211,7.211,0,0,0-5.067-2.108l-49.963-.153A7.255,7.255,0,0,0,232.279,190.492Z",
    transform: "translate(-232.267 -182.792)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4281",
    "data-name": "Group 4281",
    transform: "translate(0 1.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4278",
    "data-name": "Group 4278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4277",
    "data-name": "Group 4277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M5.355,6.735l104.977-.3-.242,83.793-104.977.3Z",
    transform: "matrix(0.606, -0.795, 0.795, 0.606, 0, 83.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4276",
    "data-name": "Group 4276",
    transform: "translate(8.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M298.078,137.527s-.1.144-.3.411l-.877,1.178c-.782,1.041-1.928,2.57-3.419,4.557l-12.926,17.162-45.688,60.51-.04-.292L301.349,272l.007.005-.325.044,63.4-83.668.036.272-48.191-37.057-13.447-10.367-3.539-2.739c-.8-.623-1.216-.959-1.216-.959s.409.3,1.209.9l3.536,2.683,13.472,10.261L364.7,188.342l.154.117-.117.155L301.4,272.329l-.141.185-.184-.141-.007-.005L234.58,221.385l-.165-.127.126-.166L280.476,160.6l12.985-17.058,3.434-4.494.883-1.146C297.976,137.649,298.078,137.527,298.078,137.527Z",
    transform: "translate(-234.415 -137.527)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M4.7,6.245l97.6-.282-.212,73.243-97.6.282Z",
    transform: "matrix(0.606, -0.795, 0.795, 0.606, 7.157, 83.971)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M305.341,273.1l-15.557-54.87,35.356.49-3.44-20.681,42.561-2.751Z",
    transform: "translate(-232.232 -143.611)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4280",
    "data-name": "Group 4280",
    transform: "translate(57.87 43.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4279",
    "data-name": "Group 4279",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M7.8.119A7.7,7.7,0,1,1,.134,7.826,7.664,7.664,0,0,1,7.8.119Z",
    transform: "translate(0 1.842) rotate(-7.768)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4287",
    "data-name": "Group 4287",
    transform: "translate(80.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4284",
    "data-name": "Group 4284",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4283",
    "data-name": "Group 4283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M.711.641,117.779.612l-.036,145.56L.675,146.2Z",
    transform: "matrix(0.041, -0.999, 0.999, 0.041, 0, 117.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4282",
    "data-name": "Group 4282",
    transform: "translate(0.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M466.609,142.493s-.238,0-.7-.017l-2.031-.072L456,142.1l-29.758-1.176-105.073-4.244.215-.2c-1.416,34.813-3.04,74.726-4.758,116.959v.013l-.221-.242,145.433,6.059-.2.185c1.483-35.25,2.712-64.468,3.571-84.882.439-10.214.783-18.225,1.019-23.69.121-2.73.213-4.821.277-6.239s.109-2.152.109-2.152-.015.711-.065,2.111-.131,3.491-.232,6.2c-.212,5.457-.522,13.453-.917,23.652-.813,20.445-1.974,49.707-3.377,85.012l-.008.193-.192-.008-145.437-5.979-.232-.01.01-.233v-.012c1.735-42.234,3.376-82.146,4.807-116.958l.008-.208.207.009,105.2,4.457,29.707,1.285,7.842.35,2.008.095C466.386,142.475,466.609,142.493,466.609,142.493Z",
    transform: "translate(-316.149 -136.257)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M.66.56,102.99.535l-.033,135.334L.627,135.894Z",
    transform: "translate(5.397 110.669) rotate(-87.644)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M322.4,251.991l49.827-61.6,27.63,40.973,20.712-20.435,37.05,46.658Z",
    transform: "translate(-316.412 -141.959)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4286",
    "data-name": "Group 4286",
    transform: "translate(74.06 29.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4285",
    "data-name": "Group 4285",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M11,.3a10.659,10.659,0,1,1-.027,21.318A10.659,10.659,0,1,1,11,.3Z",
    transform: "matrix(0.219, -0.976, 0.976, 0.219, 0, 20.809)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4299",
    "data-name": "Group 4299",
    transform: "translate(34.202 22.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M468.732,199.428l-197,27.288L292.59,371.87l195.39-27.69Z",
    transform: "translate(-264.435 -165.229)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M469.863,179.188l-194.722,40.6L305.694,363.2l193.086-40.9Z",
    transform: "translate(-264.812 -163.097)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4298",
    "data-name": "Group 4298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4289",
    "data-name": "Group 4289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M451.418,161.2,263.83,227.6l49.314,138.018,185.929-66.468Z",
    transform: "translate(-263.56 -161.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4288",
    "data-name": "Group 4288",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M451.384,161.2c.514,1.48,18.854,54.351,47.833,137.886l.062.179-.177.063L313.188,365.838l-.217.078-.078-.218-.36-1.007c-17.55-49.143-34.191-95.737-48.934-137.019l-.071-.2.2-.071,187.658-66.2L263.866,227.8l.128-.27c14.755,41.277,31.409,87.867,48.974,137l.36,1.007-.3-.14,185.944-66.428-.116.242C470.1,215.6,451.894,162.683,451.384,161.2Z",
    transform: "translate(-263.527 -161.203)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4290",
    "data-name": "Group 4290",
    transform: "translate(154.179 26.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M475.857,296.732c-.359.134-9.372-23.4-20.126-52.566s-19.185-52.923-18.825-53.058,9.37,23.4,20.128,52.572S476.217,296.6,475.857,296.732Z",
    transform: "translate(-436.894 -191.107)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4291",
    "data-name": "Group 4291",
    transform: "translate(138.158 34.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M457.843,304.966c-.36.134-9.373-23.4-20.127-52.566s-19.185-52.923-18.825-53.058,9.37,23.4,20.128,52.572S458.2,304.832,457.843,304.966Z",
    transform: "translate(-418.879 -199.341)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4292",
    "data-name": "Group 4292",
    transform: "translate(88.418 55.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M401.912,328.393c-.36.134-9.373-23.4-20.127-52.566S362.6,222.9,362.96,222.769s9.37,23.4,20.128,52.572S402.271,328.259,401.912,328.393Z",
    transform: "translate(-362.948 -222.768)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4293",
    "data-name": "Group 4293",
    transform: "translate(104.271 48.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M419.738,321.215c-.36.134-9.372-23.4-20.126-52.566s-19.185-52.923-18.826-53.058,9.37,23.4,20.128,52.571S420.1,321.081,419.738,321.215Z",
    transform: "translate(-380.775 -215.59)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4294",
    "data-name": "Group 4294",
    transform: "translate(120.125 42.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M437.564,314.037c-.359.134-9.372-23.4-20.126-52.566s-19.185-52.924-18.825-53.058,9.369,23.4,20.128,52.572S437.923,313.9,437.564,314.037Z",
    transform: "translate(-398.601 -208.411)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4295",
    "data-name": "Group 4295",
    transform: "translate(70.054 60.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M381.263,334.335c-.36.134-9.372-23.4-20.126-52.566s-19.185-52.923-18.826-53.058,9.37,23.4,20.128,52.572S381.622,334.2,381.263,334.335Z",
    transform: "translate(-342.3 -228.709)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4296",
    "data-name": "Group 4296",
    transform: "translate(52.492 66.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M361.515,341.577c-.36.134-9.372-23.4-20.126-52.567s-19.185-52.923-18.826-53.058,9.37,23.4,20.128,52.572S361.874,341.443,361.515,341.577Z",
    transform: "translate(-322.552 -235.951)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4297",
    "data-name": "Group 4297",
    transform: "translate(34.929 73.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M341.767,348.818c-.36.135-9.372-23.4-20.126-52.566s-19.185-52.923-18.826-53.058,9.37,23.4,20.128,52.572S342.126,348.684,341.767,348.818Z",
    transform: "translate(-302.804 -243.193)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M227.847,256.68l15.676,132.046a4.66,4.66,0,0,0,4.6,4.123l205.2.629a4.659,4.659,0,0,0,4.648-4.3l10.731-131.966a4.666,4.666,0,0,0-4.62-5.058l-231.61-.71A4.668,4.668,0,0,0,227.847,256.68Z",
    transform: "translate(-225.373 -148.39)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2",
    transform: "translate(422.887 136.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4447",
    "data-name": "Group 4447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M509.3,216.137l-6.917,4.983,4.031,19.951,9.093-8.159Z",
    transform: "translate(-474.616 -155.302)",
    fill: "#bf7a62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4445",
    "data-name": "Group 4445",
    transform: "translate(30.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M511.928,382.2,540.7,368.14l36.907,4.456a12.109,12.109,0,0,1,4.633,7.7,3.967,3.967,0,0,1-.42,2.924c-.829,1.164-2.519,1.308-3.9.964a34.147,34.147,0,0,0-4.085-1.227c-2.745-.327-5.28,1.44-7.343,3.292s-4.118,3.964-6.814,4.583a10.392,10.392,0,0,1-7.022-1.318c-2.155-1.134-4.079-2.664-6.183-3.893a20.746,20.746,0,0,0-12.994-2.9c-3.582.471-6.941,2.049-10.508,2.618s-9.1-.065-11.042-3.133",
    transform: "translate(-506.603 -171.312)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4408",
    "data-name": "Group 4408",
    transform: "translate(9.625 111.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4305",
    "data-name": "Group 4305",
    transform: "translate(6.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4301",
    "data-name": "Group 4301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M581.914,429.556s-23.568-80.834-24.014-83.418c-.4-2.336,3.271-58.965,4.914-73.66l-25.957.22-.011.245-12.338.306,5.53,160.773L546,435.26l-.107-53.043c10.067,25.578,21.733,54.1,21.733,54.1Z",
    transform: "translate(-524.507 -272.478)",
    fill: "#d89377"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4303",
    "data-name": "Group 4303",
    transform: "translate(10.404 69.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4302",
    "data-name": "Group 4302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M536.66,350.669c.05.007-.048.63-.107,1.762a34.891,34.891,0,0,0,.071,4.79,44.179,44.179,0,0,0,1.163,7,69.95,69.95,0,0,0,2.815,8.237c2.188,5.8,4.141,11.068,5.531,14.887.663,1.853,1.21,3.383,1.621,4.532a11.558,11.558,0,0,1,.529,1.686,11.628,11.628,0,0,1-.716-1.616l-1.774-4.473c-1.476-3.786-3.483-9.03-5.672-14.834-.542-1.453-1.073-2.87-1.586-4.242a39.342,39.342,0,0,1-1.208-4.065,41.3,41.3,0,0,1-1.065-7.089,29.127,29.127,0,0,1,.092-4.833c.058-.568.133-1.006.193-1.3A1.584,1.584,0,0,1,536.66,350.669Z",
    transform: "translate(-536.206 -350.669)",
    fill: "#bf7a62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4304",
    "data-name": "Group 4304",
    transform: "translate(15.847 95.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M547.9,412.685c.029-.49.365-17.987.365-17.987s-5.786-16.24-5.936-15.746S547.9,412.685,547.9,412.685Z",
    transform: "translate(-542.327 -378.941)",
    fill: "#bf7a62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4356",
    "data-name": "Group 4356",
    transform: "translate(0 159.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4355",
    "data-name": "Group 4355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4310",
    "data-name": "Group 4310",
    transform: "translate(0.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4307",
    "data-name": "Group 4307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4306",
    "data-name": "Group 4306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M528.281,452.723l.044-1.808,16.924.342-.081,5.962-1.046.048c-4.654.176-23.675.565-26.766-.438C513.908,455.709,528.281,452.723,528.281,452.723Z",
    transform: "translate(-516.821 -450.915)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4309",
    "data-name": "Group 4309",
    transform: "translate(22.24 1.298)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4308",
    "data-name": "Group 4308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M541.829,457.128a5.884,5.884,0,0,1,2.214-3.575,5.655,5.655,0,0,1,3.96-1.161l-.081,4.737Z",
    transform: "translate(-541.829 -452.366)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(0 3.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4311",
    "data-name": "Group 4311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M521.247,454.847s-5.043,1.366-4.432,2.208,19.848,1.177,28.346.578l-.02-.379-22.441-.2S522.227,454.906,521.247,454.847Z",
    transform: "translate(-516.763 -454.847)",
    fill: "#fff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4315",
    "data-name": "Group 4315",
    transform: "translate(0.051 5.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4314",
    "data-name": "Group 4314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4313",
    "data-name": "Group 4313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M545.412,457.473a1.56,1.56,0,0,1-.29.027l-.833.036-3.064.08c-2.588.048-6.164.068-10.113,0s-7.525-.2-10.11-.339l-3.06-.181-.831-.064a.146.146,0,1,1,0-.042l.833.026,3.062.115c2.586.1,6.159.213,10.107.279s7.521.069,10.108.057l3.065-.014.833,0A1.575,1.575,0,0,1,545.412,457.473Z",
    transform: "translate(-516.821 -456.991)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4318",
    "data-name": "Group 4318",
    transform: "translate(4.364 3.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4317",
    "data-name": "Group 4317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4316",
    "data-name": "Group 4316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M523.242,457.294a4.489,4.489,0,0,0-1.57-2.678,2.271,2.271,0,0,1,1.2,1.093A2.3,2.3,0,0,1,523.242,457.294Z",
    transform: "translate(-521.67 -454.611)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4321",
    "data-name": "Group 4321",
    transform: "translate(10.076 2.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4320",
    "data-name": "Group 4320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4319",
    "data-name": "Group 4319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M528.968,454.7c-.049.03-.281-.266-.52-.659s-.394-.737-.346-.767.281.266.52.659S529.016,454.673,528.968,454.7Z",
    transform: "translate(-528.093 -453.275)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4324",
    "data-name": "Group 4324",
    transform: "translate(11.288 1.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4323",
    "data-name": "Group 4323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4322",
    "data-name": "Group 4322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M530.5,453.971c-.039.042-.3-.141-.587-.409s-.486-.518-.448-.559.3.141.587.409S530.534,453.93,530.5,453.971Z",
    transform: "translate(-529.456 -452.998)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4327",
    "data-name": "Group 4327",
    transform: "translate(11.456 1.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4326",
    "data-name": "Group 4326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4325",
    "data-name": "Group 4325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M531.406,452.3a3.818,3.818,0,0,1-1.761-.011,3.818,3.818,0,0,1,1.761.011Z",
    transform: "translate(-529.645 -452.194)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4330",
    "data-name": "Group 4330",
    transform: "translate(11.536 0.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4329",
    "data-name": "Group 4329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4328",
    "data-name": "Group 4328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M531.731,451.058a2.46,2.46,0,0,1-2,.116,5.434,5.434,0,0,1,1-.052A5.338,5.338,0,0,1,531.731,451.058Z",
    transform: "translate(-529.735 -451.039)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4333",
    "data-name": "Group 4333",
    transform: "translate(7.246 0.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4332",
    "data-name": "Group 4332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4331",
    "data-name": "Group 4331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M528.069,453.023a3.094,3.094,0,0,1-1.082-.025,6.357,6.357,0,0,1-1.148-.276,3.135,3.135,0,0,1-.655-.284.589.589,0,0,1-.262-.344.43.43,0,0,1,.172-.432,1.978,1.978,0,0,1,2.445.627,1.946,1.946,0,0,1,.341.733.6.6,0,0,1,.023.294,3.088,3.088,0,0,0-.477-.938,1.953,1.953,0,0,0-.915-.62,1.67,1.67,0,0,0-1.291.065c-.174.125-.111.33.078.448a3.317,3.317,0,0,0,.6.272,7.482,7.482,0,0,0,1.11.311C527.657,452.981,528.07,452.99,528.069,453.023Z",
    transform: "translate(-524.911 -451.462)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4336",
    "data-name": "Group 4336",
    transform: "translate(9.998 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4335",
    "data-name": "Group 4335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4334",
    "data-name": "Group 4334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M528.13,453.016a1.082,1.082,0,0,1-.112-.759,1.8,1.8,0,0,1,.31-.79,1.085,1.085,0,0,1,.911-.539.433.433,0,0,1,.326.508,1.208,1.208,0,0,1-.192.484,3.324,3.324,0,0,1-.523.65,1.553,1.553,0,0,1-.627.43c-.019-.027.219-.191.523-.531a3.814,3.814,0,0,0,.465-.645c.152-.228.261-.64-.01-.694-.27-.03-.551.235-.721.45a1.807,1.807,0,0,0-.318.7A4.069,4.069,0,0,0,528.13,453.016Z",
    transform: "translate(-528.005 -450.926)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4339",
    "data-name": "Group 4339",
    transform: "translate(22.308 1.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4338",
    "data-name": "Group 4338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4337",
    "data-name": "Group 4337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M547.918,452.325c0,.038-.482-.055-1.245.022a5.285,5.285,0,0,0-4.474,3.462c-.269.722-.3,1.21-.341,1.2a1,1,0,0,1,.005-.342,4.524,4.524,0,0,1,.2-.911,5.127,5.127,0,0,1,4.6-3.559,4.4,4.4,0,0,1,.926.04A.978.978,0,0,1,547.918,452.325Z",
    transform: "translate(-541.848 -452.195)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4342",
    "data-name": "Group 4342",
    transform: "translate(15.275 4.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4341",
    "data-name": "Group 4341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4340",
    "data-name": "Group 4340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M538.863,455.794a13.743,13.743,0,0,1-4.924-.038c.007-.06,1.105.027,2.462.036S538.858,455.734,538.863,455.794Z",
    transform: "translate(-533.939 -455.735)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4345",
    "data-name": "Group 4345",
    transform: "translate(23.006 4.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4344",
    "data-name": "Group 4344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4343",
    "data-name": "Group 4343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M543.127,455.858c.041.043-.093.233-.21.486s-.182.476-.24.471-.083-.269.055-.559S543.092,455.817,543.127,455.858Z",
    transform: "translate(-542.632 -455.851)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4348",
    "data-name": "Group 4348",
    transform: "translate(24.122 2.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4347",
    "data-name": "Group 4347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4346",
    "data-name": "Group 4346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M544.538,454.141c.039.041-.072.216-.25.39s-.353.284-.392.242.072-.215.25-.389S544.5,454.1,544.538,454.141Z",
    transform: "translate(-543.888 -454.133)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4351",
    "data-name": "Group 4351",
    transform: "translate(25.599 2.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4350",
    "data-name": "Group 4350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4349",
    "data-name": "Group 4349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M546.515,453.369c-.013.057-.237.052-.486.135s-.43.213-.473.174.1-.271.411-.37S546.533,453.317,546.515,453.369Z",
    transform: "translate(-545.548 -453.267)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4354",
    "data-name": "Group 4354",
    transform: "translate(27.327 1.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4353",
    "data-name": "Group 4353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4352",
    "data-name": "Group 4352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M548,453.025c.02.054-.079.139-.22.191s-.27.052-.29,0,.078-.139.22-.191S547.984,452.973,548,453.025Z",
    transform: "translate(-547.491 -452.985)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4407",
    "data-name": "Group 4407",
    transform: "translate(41.345 155.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4406",
    "data-name": "Group 4406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4361",
    "data-name": "Group 4361",
    transform: "translate(0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4358",
    "data-name": "Group 4358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4357",
    "data-name": "Group 4357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M571.914,454.975l-.763-1.638,15.3-7.29,2.571,5.372-.915.513c-4.086,2.246-20.937,11.131-24.149,11.62C560.375,464.1,571.914,454.975,571.914,454.975Z",
    transform: "translate(-563.268 -446.047)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4360",
    "data-name": "Group 4360",
    transform: "translate(19.966 0.886)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4359",
    "data-name": "Group 4359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M585.932,454.047a5.91,5.91,0,0,1,.4-4.193,5.686,5.686,0,0,1,3.029-2.816l2.029,4.276Z",
    transform: "translate(-585.718 -447.037)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4363",
    "data-name": "Group 4363",
    transform: "translate(0 5.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4362",
    "data-name": "Group 4362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M566.382,460.252s-3.908,3.486-2.987,3.965,18.285-7.854,25.625-12.2l-.187-.33-20.172,9.894S567.285,459.865,566.382,460.252Z",
    transform: "translate(-563.254 -451.683)",
    fill: "#fff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4366",
    "data-name": "Group 4366",
    transform: "translate(0.014 4.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4365",
    "data-name": "Group 4365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4364",
    "data-name": "Group 4364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M589.069,451.544a1.641,1.641,0,0,1-.248.154l-.729.406-2.708,1.447c-2.294,1.2-5.486,2.827-9.05,4.541s-6.826,3.194-9.2,4.234l-2.819,1.211-.772.316a1.652,1.652,0,0,1-.275.1,1.533,1.533,0,0,1,.259-.136l.756-.351,2.792-1.27c2.358-1.074,5.606-2.574,9.169-4.286s6.761-3.315,9.072-4.486l2.736-1.388.747-.372A1.527,1.527,0,0,1,589.069,451.544Z",
    transform: "translate(-563.27 -451.543)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4369",
    "data-name": "Group 4369",
    transform: "translate(2.93 13.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4368",
    "data-name": "Group 4368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4367",
    "data-name": "Group 4367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M569.142,462.8a6.977,6.977,0,0,0-1.146-1.08,6.818,6.818,0,0,0-1.447-.612,2.252,2.252,0,0,1,1.558.439A2.286,2.286,0,0,1,569.142,462.8Z",
    transform: "translate(-566.549 -461.086)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4372",
    "data-name": "Group 4372",
    transform: "translate(7.515 9.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4371",
    "data-name": "Group 4371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4370",
    "data-name": "Group 4370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M573.114,457.932c-.029.048-.369-.111-.758-.356s-.68-.483-.649-.531.369.112.758.357S573.144,457.885,573.114,457.932Z",
    transform: "translate(-571.705 -457.036)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4375",
    "data-name": "Group 4375",
    transform: "translate(8.489 9.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4374",
    "data-name": "Group 4374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4373",
    "data-name": "Group 4373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M574.156,456.6c-.016.055-.333.008-.707-.1s-.664-.245-.649-.3.333-.009.707.1S574.172,456.541,574.156,456.6Z",
    transform: "translate(-572.799 -456.17)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4378",
    "data-name": "Group 4378",
    transform: "translate(8.357 7.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4377",
    "data-name": "Group 4377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4376",
    "data-name": "Group 4376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M574.233,454.613c.025.051-.309.267-.745.482a1.973,1.973,0,0,1-.835.3c-.025-.05.309-.267.745-.482A1.974,1.974,0,0,1,574.233,454.613Z",
    transform: "translate(-572.652 -454.602)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4381",
    "data-name": "Group 4381",
    transform: "translate(7.988 6.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4380",
    "data-name": "Group 4380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M573.972,453.331c.038.038-.265.4-.763.684a1.7,1.7,0,0,1-.972.316,5.43,5.43,0,0,1,.871-.494A5.375,5.375,0,0,1,573.972,453.331Z",
    transform: "translate(-572.237 -453.327)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4384",
    "data-name": "Group 4384",
    transform: "translate(4.458 9.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4383",
    "data-name": "Group 4383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4382",
    "data-name": "Group 4382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M571.584,456.748a3.078,3.078,0,0,1-.98.463,6.318,6.318,0,0,1-1.15.268,3.086,3.086,0,0,1-.712.038.583.583,0,0,1-.387-.189.431.431,0,0,1-.038-.464,1.977,1.977,0,0,1,2.466-.536,1.943,1.943,0,0,1,.631.5c.119.149.161.247.151.253a3.067,3.067,0,0,0-.843-.624,1.934,1.934,0,0,0-1.094-.146,1.679,1.679,0,0,0-1.127.639c-.1.191.047.345.269.366a3.219,3.219,0,0,0,.662-.028,7.309,7.309,0,0,0,1.131-.22C571.2,456.9,571.571,456.718,571.584,456.748Z",
    transform: "translate(-568.267 -456.111)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4387",
    "data-name": "Group 4387",
    transform: "translate(7.015 7.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4386",
    "data-name": "Group 4386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4385",
    "data-name": "Group 4385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M571.673,456.733a1.076,1.076,0,0,1-.437-.629,1.8,1.8,0,0,1-.074-.846,1.1,1.1,0,0,1,.576-.892.432.432,0,0,1,.517.31,1.2,1.2,0,0,1,.042.519,3.276,3.276,0,0,1-.18.817,1.576,1.576,0,0,1-.37.667c-.029-.016.11-.27.233-.71a3.854,3.854,0,0,0,.129-.786c.036-.273-.05-.69-.316-.616-.256.093-.39.458-.446.726a1.794,1.794,0,0,0,.027.772A3.922,3.922,0,0,0,571.673,456.733Z",
    transform: "translate(-571.142 -454.349)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4390",
    "data-name": "Group 4390",
    transform: "translate(19.746 0.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4389",
    "data-name": "Group 4389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4388",
    "data-name": "Group 4388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M589.229,447.031c.013.037-.455.167-1.1.579a5.32,5.32,0,0,0-2.469,5.107c.078.767.265,1.219.229,1.23a.969.969,0,0,1-.147-.308,4.463,4.463,0,0,1-.225-.9,5.163,5.163,0,0,1,2.537-5.249,4.433,4.433,0,0,1,.847-.38A.991.991,0,0,1,589.229,447.031Z",
    transform: "translate(-585.457 -447.028)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4393",
    "data-name": "Group 4393",
    transform: "translate(13.146 7.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4392",
    "data-name": "Group 4392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4391",
    "data-name": "Group 4391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M582.461,454.231a13.822,13.822,0,0,1-4.424,2.176c-.02-.056,1-.471,2.22-1.073S582.429,454.18,582.461,454.231Z",
    transform: "translate(-578.037 -454.227)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4396",
    "data-name": "Group 4396",
    transform: "translate(20.371 5.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4395",
    "data-name": "Group 4395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4394",
    "data-name": "Group 4394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M586.339,452.627c.055.02.019.25.027.529s.048.507-.006.53-.193-.2-.2-.525S586.288,452.605,586.339,452.627Z",
    transform: "translate(-586.161 -452.625)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4399",
    "data-name": "Group 4399",
    transform: "translate(20.683 3.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4398",
    "data-name": "Group 4398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4397",
    "data-name": "Group 4397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M586.834,450.452c.053.019.031.225-.051.462s-.19.412-.244.394-.03-.225.051-.462S586.781,450.434,586.834,450.452Z",
    transform: "translate(-586.511 -450.451)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4402",
    "data-name": "Group 4402",
    transform: "translate(21.563 2.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4401",
    "data-name": "Group 4401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4400",
    "data-name": "Group 4400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M588.246,448.869c.014.057-.189.152-.374.338s-.291.384-.347.368-.029-.287.2-.514S588.239,448.814,588.246,448.869Z",
    transform: "translate(-587.501 -448.843)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4405",
    "data-name": "Group 4405",
    transform: "translate(22.922 1.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4404",
    "data-name": "Group 4404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4403",
    "data-name": "Group 4403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M589.416,447.918c.041.039-.009.159-.112.269s-.22.167-.261.129.009-.16.112-.269S589.375,447.879,589.416,447.918Z",
    transform: "translate(-589.029 -447.906)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4417",
    "data-name": "Group 4417",
    transform: "translate(0 45.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4410",
    "data-name": "Group 4410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4409",
    "data-name": "Group 4409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M560.064,260.235l.008,0c-7.1-12.351-8.9-10.907-6.49-18.1l6.931-23.391L557.6,204.059a16.007,16.007,0,0,0-12.289-4.521l-14.479,1s-7.125-1.571-17.62,8.686l-7.269,6.825,9.156,17.477.456,7.922,6.6,21.682-1.76,9.56c-.766,7.276-10.491,90.7-9.172,92.015,1.377,1.377,21.646-8.83,26.555-4.66s14.791,6.726,20.366,4.931,13.936-12.959,22.372-5.432C580.516,359.546,577.757,285.536,560.064,260.235Z",
    transform: "translate(-505.94 -199.504)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M556.276,200.666s15.081,4.04,12.855,14.875c-1.1,5.329-8.325,16.442-8.325,16.442l-17.093-8.135Z",
    transform: "translate(-510.121 -199.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4411",
    "data-name": "Group 4411",
    transform: "translate(11.644 64.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M522.786,275.138a14.05,14.05,0,0,1,2.551-1.815,14.486,14.486,0,0,1,8.21-2.036,11.761,11.761,0,0,1,5.652,1.692,10.951,10.951,0,0,1,4.415,5.144,8.485,8.485,0,0,1,.623,3.68,9.03,9.03,0,0,1-1.115,3.724c-1.221,2.351-3.139,4.305-4.409,6.7-1.343,2.385-1.39,5.145-1.2,7.706.157,2.567.553,5.13-.019,7.526a10.373,10.373,0,0,1-1.3,3.294,6.239,6.239,0,0,1-2.4,2.332,5.105,5.105,0,0,1-3.074.526,7.144,7.144,0,0,1-2.68-1.026,21.137,21.137,0,0,1-3.674-3.213,34.462,34.462,0,0,0-2.737-2.422,17.24,17.24,0,0,0-1.9-1.305c-.454-.268-.711-.378-.7-.4a.7.7,0,0,1,.2.065,5.873,5.873,0,0,1,.55.252,14.4,14.4,0,0,1,1.964,1.243,31.555,31.555,0,0,1,2.808,2.378,21.388,21.388,0,0,0,3.664,3.12,6.84,6.84,0,0,0,2.56.951,4.737,4.737,0,0,0,2.846-.511,5.857,5.857,0,0,0,2.23-2.207,10,10,0,0,0,1.227-3.17c.542-2.3.151-4.809-.017-7.4a21.974,21.974,0,0,1,.016-4,10.669,10.669,0,0,1,1.227-3.954c1.319-2.477,3.236-4.425,4.417-6.7a8.609,8.609,0,0,0,1.074-3.539,8.076,8.076,0,0,0-.577-3.491A10.6,10.6,0,0,0,539,273.306a11.5,11.5,0,0,0-5.471-1.692,14.571,14.571,0,0,0-8.1,1.867,22,22,0,0,0-1.965,1.209l-.495.343A.728.728,0,0,1,522.786,275.138Z",
    transform: "translate(-519.034 -271.26)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4412",
    "data-name": "Group 4412",
    transform: "translate(38.366 83.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M583.516,346.735a.9.9,0,0,1-.234.056l-.692.119c-.61.1-1.51.238-2.672.4a61.031,61.031,0,0,1-9.919.675,30.313,30.313,0,0,1-6.821-.928,22.586,22.586,0,0,1-7.219-3.23,15.866,15.866,0,0,1-5.652-6.66,14.218,14.218,0,0,1-.76-9.339,11.183,11.183,0,0,1,2.305-4.237,27.53,27.53,0,0,1,3.464-3.1,19.743,19.743,0,0,0,3.191-3.019,9.051,9.051,0,0,0,1.726-3.767c.572-2.693.306-5.37.427-7.854a13.356,13.356,0,0,1,5.507-10.94,13.042,13.042,0,0,1,3.814-1.968,11.617,11.617,0,0,1,2.655-.54l.7-.025a.938.938,0,0,1,.239.007,15.354,15.354,0,0,0-3.541.73,13.207,13.207,0,0,0-3.717,2,13.141,13.141,0,0,0-5.276,10.746c-.107,2.457.182,5.139-.394,7.932a9.487,9.487,0,0,1-1.795,3.949,20.063,20.063,0,0,1-3.256,3.1,27.483,27.483,0,0,0-3.4,3.049,10.723,10.723,0,0,0-2.2,4.059,13.792,13.792,0,0,0,.73,9.026,15.477,15.477,0,0,0,5.478,6.491,22.359,22.359,0,0,0,7.075,3.208,30.326,30.326,0,0,0,6.735.972,65.9,65.9,0,0,0,9.886-.525l2.681-.31.7-.073A.938.938,0,0,1,583.516,346.735Z",
    transform: "translate(-549.081 -292.378)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4413",
    "data-name": "Group 4413",
    transform: "translate(6.851 139.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M537.2,375.794c-.008-.012.093-.1.3-.23a4.167,4.167,0,0,0,.859-.6c.314-.318.183-.921-.013-1.533a12.568,12.568,0,0,0-.974-2.017c-.813-1.47-1.762-3.231-2.937-5.1A28.724,28.724,0,0,0,530,360.715a16.448,16.448,0,0,0-5.982-3.743,11.738,11.738,0,0,0-5.7-.539,8.227,8.227,0,0,0-3.552,1.529c-.739.561-1.086.954-1.119.922-.012-.011.067-.115.229-.3a6.731,6.731,0,0,1,.778-.761,7.972,7.972,0,0,1,3.6-1.71,11.781,11.781,0,0,1,5.892.456,16.492,16.492,0,0,1,6.165,3.81,27.987,27.987,0,0,1,4.49,5.705c1.167,1.9,2.088,3.686,2.864,5.177a11.937,11.937,0,0,1,.932,2.094,4.073,4.073,0,0,1,.173.944,1.017,1.017,0,0,1-.273.791,3.426,3.426,0,0,1-.947.561A1.345,1.345,0,0,1,537.2,375.794Z",
    transform: "translate(-513.644 -355.917)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4414",
    "data-name": "Group 4414",
    transform: "translate(41.532 45.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M560.981,259.54c.018.016-.108.208-.428.462a3.773,3.773,0,0,1-1.571.7,4.674,4.674,0,0,1-2.546-.215,5.443,5.443,0,0,1-2.451-1.951,8.038,8.038,0,0,1-1.3-5.43,6.5,6.5,0,0,1,.5-2.265c.076.015-.115.881-.172,2.286a8.283,8.283,0,0,0,1.35,5.137,5.24,5.24,0,0,0,2.23,1.823,4.589,4.589,0,0,0,2.336.29A5.5,5.5,0,0,0,560.981,259.54Z",
    transform: "translate(-552.641 -250.838)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4415",
    "data-name": "Group 4415",
    transform: "translate(43.792 3.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M562.536,228.856a1.032,1.032,0,0,1-.345.078,5.3,5.3,0,0,1-1.013.032,6.622,6.622,0,0,1-3.474-1.312,6.275,6.275,0,0,1-1.717-1.966,6.52,6.52,0,0,1-.8-2.9,6.823,6.823,0,0,1,.665-3.256,12.793,12.793,0,0,1,2.155-2.79,6.4,6.4,0,0,0,.967-1.395,2.769,2.769,0,0,0,.255-1.544,9.6,9.6,0,0,0-1.3-2.865,4.9,4.9,0,0,1-.589-2.953,4.8,4.8,0,0,1,1-2.425,4.612,4.612,0,0,1,3.286-1.686,4.007,4.007,0,0,1,1.015.06.955.955,0,0,1,.338.106,10.548,10.548,0,0,0-1.336.014,4.442,4.442,0,0,0-3.342,6.684,9.62,9.62,0,0,1,1.373,3.005,3.214,3.214,0,0,1-.288,1.8,6.8,6.8,0,0,1-1.034,1.5,12.7,12.7,0,0,0-2.1,2.686,6.44,6.44,0,0,0-.646,3.038,6.064,6.064,0,0,0,2.29,4.617,6.768,6.768,0,0,0,3.292,1.392C562.049,228.884,562.532,228.812,562.536,228.856Z",
    transform: "translate(-555.182 -203.87)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4416",
    "data-name": "Group 4416",
    transform: "translate(6.907 10.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M517.133,238.255a11.912,11.912,0,0,0,1.434.069,5.673,5.673,0,0,0,3.495-1.462,5.29,5.29,0,0,0,1.468-5.208,5.419,5.419,0,0,0-1.75-2.791,12.29,12.29,0,0,1-2.619-2.723,6.185,6.185,0,0,1-.595-3.769c.133-1.223.415-2.36.6-3.444a10.467,10.467,0,0,0,.185-3.071,4.646,4.646,0,0,0-.965-2.422,5.215,5.215,0,0,0-3.252-1.906,9.767,9.767,0,0,0-1.431-.053,1.156,1.156,0,0,1,.366-.1,4.215,4.215,0,0,1,1.088-.028,5.254,5.254,0,0,1,3.484,1.878,4.948,4.948,0,0,1,1.092,2.579,10.674,10.674,0,0,1-.146,3.195c-.182,1.1-.453,2.237-.575,3.417a5.786,5.786,0,0,0,.546,3.492,12.266,12.266,0,0,0,2.526,2.62,5.829,5.829,0,0,1,1.856,3.022,5.526,5.526,0,0,1-5.373,6.954,4.537,4.537,0,0,1-1.081-.123A1.187,1.187,0,0,1,517.133,238.255Z",
    transform: "translate(-513.707 -211.325)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444",
    transform: "translate(3.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M538.661,150.472a10.954,10.954,0,0,1,8.735,2.053,11.086,11.086,0,0,1,4.211,7.968c.107,1.716-.1,3.684,1.1,4.9.849.859,2.146,1.045,3.205,1.62a4.944,4.944,0,0,1,2.172,5.9c-.409,1.072-1.192,1.969-1.59,3.045a8.256,8.256,0,0,0-.6,5.022c2.479,8.493-3.508,9.54-6.7,10.106-4.5.8-9.06-.641-9.527-5.379-.151-1.53-2.859-1.356-4.375-1.159-1.828.239-3.178,1.753-4.512,3.032a15.322,15.322,0,0,1-7.376,4.208,8.737,8.737,0,0,1-7.953-2.167c-1.995-2.068-2.483-5.617-.724-7.891a7.857,7.857,0,0,1-2.949-11.925c1.093-1.423,2.677-2.478,3.458-4.1.661-1.367,1.37-4.49,1.885-5.919.733-2.029,3.225-5.513,5.154-6.459",
    transform: "translate(-510.161 -148.364)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4428",
    "data-name": "Group 4428",
    transform: "translate(10.184 5.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4427",
    "data-name": "Group 4427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4426",
    "data-name": "Group 4426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4425",
    "data-name": "Group 4425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4419",
    "data-name": "Group 4419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4418",
    "data-name": "Group 4418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M547.928,197.374l-16.7.238c-.285-1.937-.852-9.483-.852-9.483s-7-.426-7.733-7.354-1.03-22.972-1.03-22.972h0a23.947,23.947,0,0,1,24.366.764l1.1.694Z",
    transform: "translate(-521.613 -154.841)",
    fill: "#d89377"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4422",
    "data-name": "Group 4422",
    transform: "translate(5.67 13.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4421",
    "data-name": "Group 4421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4420",
    "data-name": "Group 4420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M530.525,177.794a4.6,4.6,0,0,0-1.566-.182c-.252,0-.452-.042-.482-.174a1.373,1.373,0,0,1,.111-.733c.185-.655.373-1.318.569-2.012a26.941,26.941,0,0,0,1.148-5.258,26.8,26.8,0,0,0-1.672,5.114c-.182.7-.356,1.365-.528,2.024a1.608,1.608,0,0,0-.038,1.051.653.653,0,0,0,.465.359,1.559,1.559,0,0,0,.43.015A4.609,4.609,0,0,0,530.525,177.794Z",
    transform: "translate(-527.989 -169.434)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4424",
    "data-name": "Group 4424",
    transform: "translate(8.741 29.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4423",
    "data-name": "Group 4423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M531.442,191.534a16.038,16.038,0,0,0,8.749-3.421s-1.658,5.194-8.6,5.22Z",
    transform: "translate(-531.442 -188.113)",
    fill: "#bf7a62"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4432",
    "data-name": "Group 4432",
    transform: "translate(21.566 18.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4429",
    "data-name": "Group 4429",
    transform: "translate(0.271 1.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M536.461,170.587a.876.876,0,0,1-.86.87.838.838,0,0,1-.885-.811.877.877,0,0,1,.859-.87A.839.839,0,0,1,536.461,170.587Z",
    transform: "translate(-534.716 -169.775)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4431",
    "data-name": "Group 4431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4430",
    "data-name": "Group 4430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M537.863,169.5c-.11.113-.763-.394-1.7-.41s-1.638.442-1.739.324c-.049-.052.066-.257.371-.471a2.387,2.387,0,0,1,1.394-.4,2.3,2.3,0,0,1,1.353.47C537.824,169.243,537.918,169.452,537.863,169.5Z",
    transform: "translate(-534.411 -168.543)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4436",
    "data-name": "Group 4436",
    transform: "translate(11.749 18.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4433",
    "data-name": "Group 4433",
    transform: "translate(0.46 0.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M525.635,170.556a.876.876,0,0,1-.86.87.837.837,0,0,1-.885-.811.876.876,0,0,1,.859-.87A.838.838,0,0,1,525.635,170.556Z",
    transform: "translate(-523.89 -169.744)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4435",
    "data-name": "Group 4435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4434",
    "data-name": "Group 4434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M526.824,169.664c-.11.112-.763-.394-1.7-.411s-1.638.443-1.738.325c-.049-.053.064-.257.37-.471a2.4,2.4,0,0,1,1.394-.4,2.29,2.29,0,0,1,1.353.471C526.784,169.4,526.879,169.614,526.824,169.664Z",
    transform: "translate(-523.373 -168.704)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M532.6,181.226a1.838,1.838,0,0,1-.149-.7.625.625,0,0,1,.372-.572c.163-.056.356-.019.5-.114.2-.129.195-.417.305-.626a.766.766,0,0,1,.829-.337,1.627,1.627,0,0,1,.8.5,1.466,1.466,0,0,1,.5.961,1.143,1.143,0,0,1-.519.912,2.369,2.369,0,0,1-1.017.354,5.417,5.417,0,0,1-1.173.047.773.773,0,0,1-.328-.074.3.3,0,0,1-.165-.276",
    transform: "translate(-512.628 -151.375)",
    fill: "#bf7a62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4438",
    "data-name": "Group 4438",
    transform: "translate(19.291 27.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M531.853,181.343a4.447,4.447,0,0,0,3.579-2.687",
    transform: "translate(-531.853 -178.654)",
    fill: "#bf7a62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4437",
    "data-name": "Group 4437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M535.432,178.656a2.737,2.737,0,0,1-1.291,2.016,2.7,2.7,0,0,1-2.288.671,16.32,16.32,0,0,0,2.011-1.045C534.867,179.562,535.307,178.6,535.432,178.656Z",
    transform: "translate(-531.853 -178.654)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4440",
    "data-name": "Group 4440",
    transform: "translate(11.774 15.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M523.422,166.871a3.982,3.982,0,0,1,2.577-.289",
    transform: "translate(-523.403 -166.033)",
    fill: "#bf7a62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4439",
    "data-name": "Group 4439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M526,166.528c-.069.252-.63.315-1.261.392s-1.193.128-1.316-.1.384-.732,1.213-.823S526.072,166.288,526,166.528Z",
    transform: "translate(-523.401 -165.98)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4442",
    "data-name": "Group 4442",
    transform: "translate(21.471 16.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M534.315,166.961a4.863,4.863,0,0,1,3.638.2",
    transform: "translate(-534.306 -166.237)",
    fill: "#bf7a62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4441",
    "data-name": "Group 4441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M537.952,167.107c-.123.234-.9.054-1.825.012-.927-.06-1.716.034-1.813-.212-.106-.227.71-.785,1.864-.718S538.082,166.893,537.952,167.107Z",
    transform: "translate(-534.305 -166.183)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M536.444,150.114a5.509,5.509,0,0,0-3.951-1.9,12.944,12.944,0,0,0-11.832,5.392c-1.524,2.2-2.291,5.267-.867,7.533a4.65,4.65,0,0,0,8.409-1.178,3.893,3.893,0,1,0,7.774-.352,7.116,7.116,0,0,0,2.473,3.563c1.242.781,3.186.593,3.827-.732.779.932,1.877,1.882,3.054,1.593a2.39,2.39,0,0,0,1.589-2.4,6.16,6.16,0,0,0-1.01-2.9c-2.28-3.992-5.644-7.659-10.059-8.871",
    transform: "translate(-511.144 -148.14)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M544.324,160.459a12.562,12.562,0,0,1,.093,12.09,20.4,20.4,0,0,0-1.893,3.508,3.329,3.329,0,0,0,.81,3.657c.651.488,1.644.735,1.8,1.537a2.219,2.219,0,0,1-.245,1.176,8,8,0,0,0-.209,5.041,4.348,4.348,0,0,0,2.954,3.609c1.287.578,1.983,1.562,4.767.842,4.875-1.261,3.154-12.215,2.7-17.257s-2.789-14.023-5.6-18.222",
    transform: "translate(-513.72 -149.014)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M531.708,198.954s-5.051,18.974-1.832,17.094,18.847-14.374,18.847-14.374l-7.9-6Z",
    transform: "translate(-512.224 -153.147)",
    fill: "#d89377"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446",
    transform: "translate(0 65.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M477.761,234.377c-.559-1.856-7.549-5.688-6.491-6.722,1.378-1.346,7.115,4.331,7.635,4.774s1.156-.314.665-.688c-.7-.539-7.967-6.383-6.626-7.717.743-.741,1.913.766,1.913.766s6.408,5.983,7.02,5.33-3.027-4.3-4.341-5.444c-1.3-1.125-1.31-2.218-.352-2.4.654-.121,4.757,3.27,6.03,4.427s4.714,4.4,4.271,1.381c-.007-.047-.008-.091-.014-.139-.517-2.957.059-5.407.7-6a1.031,1.031,0,0,1,1.662.828,1.059,1.059,0,0,1-.023.436c-.018.063-.025.152-.039.224a15.04,15.04,0,0,0,.194,3.069,8.161,8.161,0,0,0,.839,2.614c.494.942.956,1.737,1.362,2.392,4.674,2.611,18.119,9.5,31.6,10.582,2.434.2,13.19-16.885,13.19-16.885l15.981,7.606A156.759,156.759,0,0,1,540.2,253.029c-13.491,18.443-55.665-12.292-55.665-12.292h0l-.395-.2a97.877,97.877,0,0,1-9.321-5.294c-3.627-2.578-3.409-2.917-3.048-3.3C472.744,230.918,478.319,236.235,477.761,234.377Z",
    transform: "translate(-471.161 -221.707)",
    fill: "#d89377"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1",
    transform: "translate(93.701 122.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4618",
    "data-name": "Group 4618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560",
    transform: "translate(0 128.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(79.09 152.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4450",
    "data-name": "Group 4450",
    transform: "translate(0.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4449",
    "data-name": "Group 4449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4448",
    "data-name": "Group 4448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M203.9,454.808l-.085-7.341-13.669.072.011,10.741.848.05c3.773.191,19.2.7,21.715-.08C215.526,457.378,203.9,454.808,203.9,454.808Z",
    transform: "translate(-190.145 -447.467)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4453",
    "data-name": "Group 4453",
    transform: "translate(0 10.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    "data-name": "Group 4452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4451",
    "data-name": "Group 4451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M189.939,459.189a1.25,1.25,0,0,0,.235.024l.675.038,2.485.1c2.1.066,5,.119,8.2.107s6.105-.088,8.2-.17l2.484-.115.675-.043a1.375,1.375,0,0,0,.235-.027,1.294,1.294,0,0,0-.236-.007l-.677.012-2.485.063c-2.1.053-5,.109-8.2.122s-6.1-.021-8.2-.058l-2.485-.043-.677-.006A1.167,1.167,0,0,0,189.939,459.189Z",
    transform: "translate(-189.939 -459.092)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4456",
    "data-name": "Group 4456",
    transform: "translate(18.392 8.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4455",
    "data-name": "Group 4455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4454",
    "data-name": "Group 4454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M210.645,459.274a3.629,3.629,0,0,1,1.3-2.156,2.221,2.221,0,0,0-1.3,2.156Z",
    transform: "translate(-210.62 -457.113)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4459",
    "data-name": "Group 4459",
    transform: "translate(14.367 7.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4458",
    "data-name": "Group 4458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M206.1,457.113c.038.024.23-.213.429-.53s.326-.594.288-.618-.23.213-.429.53S206.062,457.089,206.1,457.113Z",
    transform: "translate(-206.094 -455.963)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4462",
    "data-name": "Group 4462",
    transform: "translate(13.261 7.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4461",
    "data-name": "Group 4461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4460",
    "data-name": "Group 4460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M204.854,456.5c.031.034.246-.112.48-.326s.4-.415.369-.449-.245.112-.48.326S204.823,456.47,204.854,456.5Z",
    transform: "translate(-204.85 -455.725)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4465",
    "data-name": "Group 4465",
    transform: "translate(12.559 6.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4464",
    "data-name": "Group 4464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4463",
    "data-name": "Group 4463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M204.061,455.14a3.106,3.106,0,1,0,.714-.079A1.589,1.589,0,0,0,204.061,455.14Z",
    transform: "translate(-204.061 -455.061)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4468",
    "data-name": "Group 4468",
    transform: "translate(12.314 5.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4467",
    "data-name": "Group 4467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4466",
    "data-name": "Group 4466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M203.786,454.125a2,2,0,0,0,1.618.115,4.259,4.259,0,0,0-.809-.053A4.4,4.4,0,0,0,203.786,454.125Z",
    transform: "translate(-203.785 -454.111)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(14.832 6.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M206.617,455.758a2.524,2.524,0,0,0,.879-.01,5.119,5.119,0,0,0,.934-.212,2.545,2.545,0,0,0,.534-.224.482.482,0,0,0,.216-.276.349.349,0,0,0-.135-.353,1.6,1.6,0,0,0-1.989.484,1.58,1.58,0,0,0-.284.59.5.5,0,0,0-.022.239,2.515,2.515,0,0,1,.4-.756,1.587,1.587,0,0,1,.749-.494,1.353,1.353,0,0,1,1.047.067c.141.1.086.268-.068.362a2.636,2.636,0,0,1-.493.215,6.072,6.072,0,0,1-.9.241C206.951,455.729,206.617,455.731,206.617,455.758Z",
    transform: "translate(-206.617 -454.514)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474",
    transform: "translate(13.907 5.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4473",
    "data-name": "Group 4473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4472",
    "data-name": "Group 4472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M206.73,455.751a.873.873,0,0,0,.1-.614,1.45,1.45,0,0,0-.243-.644.882.882,0,0,0-.734-.447.352.352,0,0,0-.269.41.963.963,0,0,0,.151.394,2.7,2.7,0,0,0,.417.533,1.271,1.271,0,0,0,.5.355c.015-.021-.176-.158-.419-.437a3.134,3.134,0,0,1-.371-.529c-.121-.186-.205-.521.015-.562.22-.022.446.2.58.372a1.453,1.453,0,0,1,.252.573A3.263,3.263,0,0,1,206.73,455.751Z",
    transform: "translate(-205.577 -454.045)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477",
    transform: "translate(0.261 6.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M190.233,454.983c0,.031.391-.039,1.009.031a4.287,4.287,0,0,1,3.594,2.854c.211.589.233.984.264.981a.819.819,0,0,0,0-.277,3.631,3.631,0,0,0-.153-.741,4.158,4.158,0,0,0-3.693-2.935,3.578,3.578,0,0,0-.751.023A.789.789,0,0,0,190.233,454.983Z",
    transform: "translate(-190.233 -454.887)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480",
    transform: "translate(1.543 1.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M191.783,448.59a48.06,48.06,0,0,0-.045,5.652,48.576,48.576,0,0,0,.045-5.652Z",
    transform: "translate(-191.675 -448.59)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483",
    transform: "translate(6.864 9.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M197.657,457.894a11.154,11.154,0,0,0,3.995.019c-.005-.048-.9.011-2,0S197.662,457.846,197.657,457.894Z",
    transform: "translate(-197.657 -457.877)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486",
    transform: "translate(4.178 9.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M194.643,457.9c-.033.034.075.19.166.4s.143.388.19.385.069-.217-.04-.454S194.673,457.871,194.643,457.9Z",
    transform: "translate(-194.637 -457.899)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    transform: "translate(3.163 8.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M193.5,456.5c-.033.033.056.175.2.319s.284.233.316.2-.056-.174-.2-.319S193.534,456.464,193.5,456.5Z",
    transform: "translate(-193.495 -456.49)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    transform: "translate(1.721 7.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M191.875,455.85c.01.047.191.044.392.115s.347.177.382.146-.079-.221-.33-.3S191.861,455.808,191.875,455.85Z",
    transform: "translate(-191.874 -455.77)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    transform: "translate(0.69 7.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M190.717,455.556c-.016.043.063.114.176.157s.22.045.236,0-.062-.114-.176-.157S190.734,455.513,190.717,455.556Z",
    transform: "translate(-190.715 -455.525)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4547",
    "data-name": "Group 4547",
    transform: "translate(0 136.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M114.442,442.238l3.861-6.23-11.552-7.351-5.745,9.053.687.5c3.075,2.206,15.793,11,18.333,11.707C122.859,450.707,114.442,442.238,114.442,442.238Z",
    transform: "translate(-101.006 -428.658)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(0.005 8.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M101.012,438.362a1.159,1.159,0,0,0,.184.149l.549.4,2.042,1.428c1.732,1.194,4.148,2.811,6.852,4.538s5.19,3.236,7,4.3l2.155,1.25.591.329a1.3,1.3,0,0,0,.212.106,1.289,1.289,0,0,0-.195-.134l-.576-.357-2.126-1.295c-1.8-1.093-4.268-2.618-6.973-4.344s-5.127-3.326-6.875-4.495l-2.071-1.384-.566-.372A1.41,1.41,0,0,0,101.012,438.362Z",
    transform: "translate(-101.012 -438.362)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506",
    transform: "translate(15.358 17.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M118.279,449.663a3.609,3.609,0,0,1,2.251-1.11,1.829,1.829,0,0,0-1.3.2A1.85,1.85,0,0,0,118.279,449.663Z",
    transform: "translate(-118.275 -448.509)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(13.048 14.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M115.679,445.36c.02.041.308-.055.645-.214s.593-.323.574-.365-.308.055-.645.214S115.659,445.318,115.679,445.36Z",
    transform: "translate(-115.678 -444.771)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512",
    transform: "translate(12.426 13.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M114.979,444.181c.008.045.268.039.58-.014s.558-.132.551-.178-.267-.039-.579.013S114.972,444.135,114.979,444.181Z",
    transform: "translate(-114.979 -443.958)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    transform: "translate(12.524 12.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M115.091,442.559c-.025.039.223.245.554.462s.619.36.644.321-.223-.245-.554-.462S115.116,442.521,115.091,442.559Z",
    transform: "translate(-115.089 -442.553)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518",
    transform: "translate(12.806 11.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M115.41,441.551c-.035.027.175.347.549.625a1.379,1.379,0,0,0,.753.349c.019-.044-.3-.216-.655-.482S115.447,441.52,115.41,441.551Z",
    transform: "translate(-115.406 -441.548)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    transform: "translate(14.062 13.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M116.835,444.533a2.524,2.524,0,0,0,.745.468,5.083,5.083,0,0,0,.9.328,2.542,2.542,0,0,0,.57.1.47.47,0,0,0,.33-.115.349.349,0,0,0,.076-.37,1.607,1.607,0,0,0-1.935-.672,1.578,1.578,0,0,0-.556.344c-.11.109-.154.182-.146.19a2.459,2.459,0,0,1,.738-.422,1.582,1.582,0,0,1,.9-.01,1.362,1.362,0,0,1,.846.624c.063.163-.071.273-.252.268a2.579,2.579,0,0,1-.53-.087,6.105,6.105,0,0,1-.89-.286C117.133,444.689,116.849,444.509,116.835,444.533Z",
    transform: "translate(-116.818 -444.174)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524",
    transform: "translate(13.891 12.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M116.983,444.525c.005.015.235-.106.412-.463a1.461,1.461,0,0,0,.141-.675.89.89,0,0,0-.378-.775.349.349,0,0,0-.446.2.963.963,0,0,0-.084.414,2.678,2.678,0,0,0,.067.675,1.273,1.273,0,0,0,.234.573c.025-.01-.063-.228-.119-.595a3.072,3.072,0,0,1-.028-.646c0-.223.106-.55.313-.465.2.1.27.407.29.628a1.472,1.472,0,0,1-.1.619A3.237,3.237,0,0,1,116.983,444.525Z",
    transform: "translate(-116.626 -442.586)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527",
    transform: "translate(2.242 5.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4526",
    "data-name": "Group 4526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M103.527,434.977c-.014.028.35.179.833.574a4.323,4.323,0,0,1,1.5,4.353c-.137.61-.331.956-.3.969a.8.8,0,0,0,.148-.234,3.6,3.6,0,0,0,.269-.707,4.193,4.193,0,0,0-1.539-4.474,3.642,3.642,0,0,0-.646-.388A.791.791,0,0,0,103.527,434.977Z",
    transform: "translate(-103.527 -434.975)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4530",
    "data-name": "Group 4530",
    transform: "translate(3.415 1.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4529",
    "data-name": "Group 4529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M107.913,430.426a48.179,48.179,0,0,0-3.065,4.736,48.037,48.037,0,0,0,3.065-4.736Z",
    transform: "translate(-104.846 -430.426)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4533",
    "data-name": "Group 4533",
    transform: "translate(6.411 11.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4532",
    "data-name": "Group 4532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4531",
    "data-name": "Group 4531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M108.216,441.423a11.259,11.259,0,0,0,3.355,2.182c.022-.043-.761-.478-1.684-1.08S108.246,441.384,108.216,441.423Z",
    transform: "translate(-108.215 -441.421)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4536",
    "data-name": "Group 4536",
    transform: "translate(4.018 9.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4535",
    "data-name": "Group 4535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4534",
    "data-name": "Group 4534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M105.657,439.807c-.046.011-.039.2-.072.423s-.088.4-.046.427.175-.145.21-.4S105.7,439.794,105.657,439.807Z",
    transform: "translate(-105.525 -439.806)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4539",
    "data-name": "Group 4539",
    transform: "translate(3.936 8.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4538",
    "data-name": "Group 4538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4537",
    "data-name": "Group 4537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M105.467,438.006c-.045.01-.046.178,0,.376s.113.351.158.341.046-.178,0-.376S105.511,438,105.467,438.006Z",
    transform: "translate(-105.432 -438.005)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542",
    transform: "translate(3.056 7.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M104.444,436.589c-.017.045.138.141.269.31s.2.336.244.329.051-.228-.116-.434S104.455,436.546,104.444,436.589Z",
    transform: "translate(-104.443 -436.574)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    transform: "translate(2.317 6.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4543",
    "data-name": "Group 4543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M103.628,435.714c-.037.028-.008.13.064.228s.161.156.2.128.008-.129-.064-.227S103.664,435.687,103.628,435.714Z",
    transform: "translate(-103.612 -435.708)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557",
    transform: "translate(0.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4554",
    "data-name": "Group 4554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    transform: "translate(0 1.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4548",
    "data-name": "Group 4548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M167.448,283.958s11.6,77.518,9.911,81.265-55.834,63.652-55.834,63.652l-19.955-13.3s47.3-59.907,46.94-61.346-17.923-76.5-17.923-76.5Z",
    transform: "translate(-101.569 -277.723)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4553",
    "data-name": "Group 4553",
    transform: "translate(20.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4552",
    "data-name": "Group 4552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4551",
    "data-name": "Group 4551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M126.585,276.536l-.7,2.877a34.036,34.036,0,0,0,3.537,24.982l31.449,54.842A44.222,44.222,0,0,1,165.69,371.7l14.2,63.344h21.906c0,1.32-5.668-52.181-8.506-69.949-2.142-13.4-19.968-55-28.6-74.642l5.35-6.622-9.294-1.561Z",
    transform: "translate(-124.917 -276.536)",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4555",
    "data-name": "Group 4555",
    transform: "translate(61.204 13.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M170.394,291.926a4.071,4.071,0,0,1,.485.872c.285.573.679,1.413,1.149,2.457.942,2.087,2.178,5,3.439,8.261s2.305,6.251,3.013,8.43c.354,1.089.628,1.975.8,2.592a4.169,4.169,0,0,1,.228.972,4.133,4.133,0,0,1-.4-.914l-.941-2.541c-.786-2.149-1.877-5.114-3.135-8.37s-2.445-6.182-3.308-8.3q-.6-1.48-1.013-2.513A4.19,4.19,0,0,1,170.394,291.926Z",
    transform: "translate(-170.39 -291.926)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4556",
    "data-name": "Group 4556",
    transform: "translate(37.942 49.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M170.086,388.131a3.165,3.165,0,0,1-.142-.617l-.318-1.78q-.1-.588-.218-1.287-.156-.7-.335-1.517c-.243-1.087-.491-2.332-.884-3.678l-.574-2.124-.719-2.273c-.468-1.581-1.118-3.22-1.74-4.964-1.351-3.451-2.993-7.181-4.912-11a207.349,207.349,0,0,0-11.052-18.9l-3.649-5.549-.99-1.512a3.229,3.229,0,0,1-.318-.546,3.3,3.3,0,0,1,.4.492l1.06,1.462c.915,1.275,2.213,3.139,3.774,5.471a183.183,183.183,0,0,1,11.192,18.874c1.925,3.835,3.563,7.586,4.9,11.059.614,1.757,1.252,3.407,1.707,5q.362,1.185.7,2.29.285,1.115.548,2.142c.374,1.357.6,2.612.82,3.708l.3,1.529q.1.7.18,1.3c.1.743.173,1.339.232,1.8A3.213,3.213,0,0,1,170.086,388.131Z",
    transform: "translate(-144.233 -332.379)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558",
    transform: "translate(2.922 135.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M124.753,441.535a3.823,3.823,0,0,1-.913-.3,22.1,22.1,0,0,1-2.379-1.1,55.139,55.139,0,0,1-7.233-4.73c-2.7-2.024-5.123-3.861-6.955-5.083s-3.015-1.9-2.979-1.964a3.783,3.783,0,0,1,.88.389c.557.271,1.334.717,2.277,1.3,1.889,1.157,4.359,2.965,7.052,4.984a71.313,71.313,0,0,0,7.115,4.816C123.524,440.932,124.785,441.458,124.753,441.535Z",
    transform: "translate(-104.292 -428.35)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(74.989 154.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M208.427,449.977a3.431,3.431,0,0,1-.911.052l-2.476-.018-8.162-.069-8.164.051-2.476.012a3.422,3.422,0,0,1-.911-.054,3.433,3.433,0,0,1,.9-.127c.583-.053,1.428-.107,2.473-.16,2.09-.107,4.98-.191,8.174-.188s6.083.095,8.173.206c1.045.055,1.89.113,2.473.166A3.425,3.425,0,0,1,208.427,449.977Z",
    transform: "translate(-185.328 -449.476)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    transform: "translate(26.895 13.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M141.714,183.879a9.93,9.93,0,0,1-5.633-.855,5.333,5.333,0,0,1-2.968-4.638c.035-1.134.524-2.253.338-3.371a10.732,10.732,0,0,0-1.546-3.02,6.291,6.291,0,0,1,1.671-7.672c1.165-.893,2.654-1.361,3.63-2.459,1.156-1.3,1.341-3.178,2.047-4.771a7.681,7.681,0,0,1,5.712-4.4,24.323,24.323,0,0,0,4.1-.5,14.032,14.032,0,0,0,3.031-1.816,13.959,13.959,0,0,1,10.454-1.971,8.369,8.369,0,0,1,4.238,2.1c1.269,1.27,2.91,2.646,3.368,4.387.54,2.053-.121,4.63-.67,6.681a5.47,5.47,0,0,1-4.283,4.176",
    transform: "translate(-131.248 -148.106)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4579",
    "data-name": "Group 4579",
    transform: "translate(6.482 9.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    transform: "translate(3.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M142.512,200.768l16.7.239c.285-1.937.852-9.483.852-9.483s7-.426,7.733-7.355,1.03-22.972,1.03-22.972h0a23.95,23.95,0,0,0-24.367.765l-1.1.694Z",
    transform: "translate(-142.512 -158.236)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565",
    transform: "translate(18.108 13.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M162.874,181.189a4.591,4.591,0,0,1,1.566-.182c.251,0,.451-.042.482-.174a1.372,1.372,0,0,0-.111-.733l-.569-2.013a26.858,26.858,0,0,1-1.148-5.257,26.776,26.776,0,0,1,1.672,5.113c.182.7.356,1.365.527,2.025a1.608,1.608,0,0,1,.039,1.051.657.657,0,0,1-.466.359,1.626,1.626,0,0,1-.429.015A4.609,4.609,0,0,1,162.874,181.189Z",
    transform: "translate(-162.874 -172.829)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(8.824 29.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M161.183,194.929a16.047,16.047,0,0,1-8.749-3.421s1.658,5.194,8.6,5.22Z",
    transform: "translate(-152.434 -191.508)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575",
    transform: "translate(0 11.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4571",
    "data-name": "Group 4571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M143.009,171.32c-.137-.056-4.721-.809-4.462,4.675s5.677,3.406,5.679,3.249S143.009,171.32,143.009,171.32Z",
    transform: "translate(-138.537 -171.255)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574",
    transform: "translate(1.396 1.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M142.641,177.618c-.025-.017-.092.071-.249.153a.946.946,0,0,1-.709.048,2.367,2.367,0,0,1-1.187-2.068,3.161,3.161,0,0,1,.2-1.38,1.1,1.1,0,0,1,.679-.767.483.483,0,0,1,.573.234c.08.15.051.261.08.269s.112-.1.058-.322a.612.612,0,0,0-.23-.333.711.711,0,0,0-.532-.115,1.338,1.338,0,0,0-.952.9,3.268,3.268,0,0,0-.257,1.544,2.482,2.482,0,0,0,1.5,2.3,1.015,1.015,0,0,0,.862-.186C142.637,177.75,142.659,177.627,142.641,177.618Z",
    transform: "translate(-140.107 -173.328)",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(15.427 10.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M155.9,171.035c-.075-.1.055-.358.408-.631a3.175,3.175,0,0,1,3.287-.227c.387.222.55.462.49.568-.137.227-1.021-.076-2.1.015C156.9,170.819,156.071,171.241,155.9,171.035Z",
    transform: "translate(-155.884 -169.823)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4578",
    "data-name": "Group 4578",
    transform: "translate(25.112 11.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M166.777,171.175c-.048-.25.7-.6,1.678-.6s1.724.356,1.675.6-.794.327-1.678.327S166.823,171.431,166.777,171.175Z",
    transform: "translate(-166.775 -170.579)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M141.625,163.784l.776,5.058a4.23,4.23,0,0,0,.8,2.232,2.975,2.975,0,0,0,3.644.234c1.663-.975,2.577-2.841,3.279-4.645s1.324-3.719,2.679-5.1a6.609,6.609,0,0,0,7.657,1.42c1.112-.563,2.037-1.434,3.1-2.077a4.049,4.049,0,0,1,3.548-.573c.631.263,1.2.784,1.878.753a1.519,1.519,0,0,0,1.224-.846,2.63,2.63,0,0,0,.225-1.524,5.981,5.981,0,0,0-3.548-4.336,18.307,18.307,0,0,0-8.115-1.4,30.5,30.5,0,0,0-7.826.778,13.509,13.509,0,0,0-6.742,3.893,8.83,8.83,0,0,0-2.235,7.321",
    transform: "translate(-132.397 -148.619)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M166.007,158.525a8.306,8.306,0,0,0,2.623,4.581,3.518,3.518,0,0,0,2.308,1.041,2.873,2.873,0,0,0,2.517-2.874,5.5,5.5,0,0,0-1.706-3.747,5.161,5.161,0,0,0-3.469-1.842,2.653,2.653,0,0,0-2.774,2.34",
    transform: "translate(-135.04 -148.904)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4583",
    "data-name": "Group 4583",
    transform: "translate(21.484 21.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4580",
    "data-name": "Group 4580",
    transform: "translate(1.451 1.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M157.037,173.982a.876.876,0,0,0,.86.87.838.838,0,0,0,.885-.811.877.877,0,0,0-.859-.87A.839.839,0,0,0,157.037,173.982Z",
    transform: "translate(-157.037 -173.17)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4582",
    "data-name": "Group 4582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M155.42,172.9c.11.113.762-.394,1.7-.411s1.638.443,1.738.325c.049-.052-.065-.257-.37-.471a2.391,2.391,0,0,0-1.394-.4,2.29,2.29,0,0,0-1.353.47C155.459,172.638,155.366,172.847,155.42,172.9Z",
    transform: "translate(-155.405 -171.938)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4587",
    "data-name": "Group 4587",
    transform: "translate(31.3 21.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4584",
    "data-name": "Group 4584",
    transform: "translate(1.262 0.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M167.863,173.95a.876.876,0,0,0,.86.87.838.838,0,0,0,.885-.811.877.877,0,0,0-.859-.87A.839.839,0,0,0,167.863,173.95Z",
    transform: "translate(-167.863 -173.138)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4586",
    "data-name": "Group 4586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M166.458,173.058c.111.113.764-.394,1.7-.41s1.639.442,1.739.324c.049-.052-.065-.257-.371-.471a2.386,2.386,0,0,0-1.394-.4,2.3,2.3,0,0,0-1.353.47C166.5,172.8,166.4,173.008,166.458,173.058Z",
    transform: "translate(-166.444 -172.099)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4588",
    "data-name": "Group 4588",
    transform: "translate(25.152 30.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M162.278,185c.009.057-.235.166-.655.14a2.274,2.274,0,0,1-1.464-.7,2.3,2.3,0,0,1-.629-1.5c-.006-.424.113-.664.169-.652.127,0,.03,1.026.8,1.832S162.283,184.868,162.278,185Z",
    transform: "translate(-159.531 -182.282)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4591",
    "data-name": "Group 4591",
    transform: "translate(57.844 78.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    "data-name": "Group 4590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M166.149,224.821l13.878-4.669s9.666,23,12.153,23.224c13.779,1.264,28.521-3.332,33.691-5.149.525-.592,1.123-1.3,1.791-2.175a8.329,8.329,0,0,0,1.3-2.491,12.7,12.7,0,0,0,.737-3.425,1.08,1.08,0,0,1,1.858-.856c.6.775.749,3.746-.611,6.942s3.453.653,5.225-.242,7.378-3.4,8.083-3.075c1.033.484.709,1.687-1.081,2.539-1.811.862-6.975,3.787-6.46,4.705s9.46-3.774,9.46-3.774,1.753-1.311,2.382-.27c1.137,1.877-8.745,6.146-9.7,6.528-.66.267-.136,1.284.558.961.714-.334,8.822-4.876,10-2.975.9,1.458-8.1,3.587-9.258,5.468s6.66-2.312,7.464-.883c.3.532.45.97-4.388,2.726a102.331,102.331,0,0,1-10.781,2.769l.017.05s-49.789,22.415-58.743.784C164.6,229.5,166.149,224.821,166.149,224.821Z",
    transform: "translate(-166.049 -220.152)",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M179.647,225.657c-5.554-13.089-12.836-18.216-16.676-20.109a11.087,11.087,0,0,0-4.3-1.112h0l-.462-2.249L139.8,200.519l-.451,2.862-2.7-.147s-15.873,1.6-15.9,20.094c-.013,8.651,4.631,17.069,6.27,21.192,1.022,8.628-2.657,24.269-2.558,28.085l45.115,3.221,1.909-28.371-.422-2.662,14.852-4.575Zm-39.85-22.25h0Z",
    transform: "translate(-103.19 -139.732)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4595",
    "data-name": "Group 4595",
    transform: "translate(51.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M284.247,156.35a51.99,51.99,0,0,0-35.223-19.32,52.554,52.554,0,0,0-57.69,46.829h0a52.856,52.856,0,0,0,17.7,45.328l-45.884,54.168L169.731,289,216,234.376a51.892,51.892,0,0,0,21.883,7.521,53,53,0,0,0,5.669.305,51.829,51.829,0,0,0,32.816-11.7,52.95,52.95,0,0,0,7.879-74.152Zm2.724,37.793a43.813,43.813,0,0,1-16.035,29.587,43.278,43.278,0,0,1-32.134,9.514,44.027,44.027,0,0,1,9.3-87.56,43.412,43.412,0,0,1,29.41,16.131A43.928,43.928,0,0,1,286.971,194.143Z",
    transform: "translate(-158.898 -133.013)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M280.024,152.2a51.986,51.986,0,0,0-35.222-19.32,52.555,52.555,0,0,0-57.691,46.829h0a52.859,52.859,0,0,0,17.7,45.328l-46.439,54.612,7.039,5.664,46.37-55.088a51.892,51.892,0,0,0,21.883,7.521,53.031,53.031,0,0,0,5.67.305,51.829,51.829,0,0,0,32.816-11.7,52.949,52.949,0,0,0,7.878-74.152Zm2.725,37.793a43.813,43.813,0,0,1-16.035,29.587,43.278,43.278,0,0,1-32.134,9.514,44.027,44.027,0,0,1,9.3-87.56,43.405,43.405,0,0,1,29.409,16.131A43.928,43.928,0,0,1,282.749,189.99Z",
    transform: "translate(-158.369 -132.576)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593",
    transform: "translate(47.579 33.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M221.366,217.783a2.2,2.2,0,0,1-.346-.387c-.209-.268-.537-.649-.91-1.176a40.1,40.1,0,0,1-2.921-4.632,43.852,43.852,0,0,1-2.967-35.126,40.319,40.319,0,0,1,2.1-5.06c.278-.584.538-1.015.7-1.314a2.124,2.124,0,0,1,.276-.44,2.191,2.191,0,0,1-.193.483c-.134.312-.367.756-.62,1.349a48.064,48.064,0,0,0-1.954,5.086,45.048,45.048,0,0,0,2.945,34.866,47.731,47.731,0,0,0,2.78,4.683c.348.542.652.939.837,1.225A2.188,2.188,0,0,1,221.366,217.783Z",
    transform: "translate(-211.87 -169.647)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4594",
    "data-name": "Group 4594",
    transform: "translate(57.232 27.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M224.756,162.925c.077.108-.457.608-.99,1.313s-.883,1.346-1.008,1.3.052-.82.64-1.584S224.689,162.821,224.756,162.925Z",
    transform: "translate(-222.724 -162.908)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4617",
    "data-name": "Group 4617",
    transform: "translate(18.597 61.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4597",
    "data-name": "Group 4597",
    transform: "translate(45.559 14.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4596",
    "data-name": "Group 4596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M173.156,217.567a6.641,6.641,0,0,1,.323,1.235c.18.8.414,1.966.681,3.409.538,2.884,1.186,6.89,1.733,11.335s.885,8.492,1.061,11.422c.088,1.465.142,2.651.162,3.472a6.769,6.769,0,0,1-.013,1.277,6.705,6.705,0,0,1-.166-1.266c-.081-.9-.185-2.066-.309-3.459-.259-2.919-.649-6.95-1.193-11.389s-1.142-8.441-1.6-11.337c-.216-1.381-.4-2.533-.537-3.43A6.832,6.832,0,0,1,173.156,217.567Z",
    transform: "translate(-173.147 -217.567)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4599",
    "data-name": "Group 4599",
    transform: "translate(3.712 28.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4598",
    "data-name": "Group 4598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M192.49,263.093s-49.773,22.465-58.726.833c-9.122-22.037-7.573-26.711-7.573-26.711l13.879-4.669s9.665,23,12.153,23.224c13.778,1.264,28.52-3.332,33.69-5.149.525-.592,1.124-1.3,1.791-2.176.572-.748,1.168-1.825,1.754-2.563,1.315-1.656,2.355-1.932,2.929-2.586,1.375-1.564,2.631-.421,2.033.421a15.072,15.072,0,0,0-3.435,4.9c-1.36,3.195,3.486,1.626,5.4,1.118,2.119-.561,6.1-2.117,6.1-2.117.092.939-.962,2.827-2.752,3.679a28.323,28.323,0,0,1-2.982,1.248s3.679-.449,3.777.394-1.089,7.084-5,8.938Z",
    transform: "translate(-126.092 -232.545)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M136.374,210.139l8.94,27.174-19.569,7.782s-10.209-26.685,2.72-33.218Z",
    transform: "translate(-121.918 -201.963)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4606",
    "data-name": "Group 4606",
    transform: "translate(3.779 4.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4600",
    "data-name": "Group 4600",
    transform: "translate(5.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M147.761,235.783c-.01.008-.109-.071-.265-.254a5.012,5.012,0,0,1-.586-.874,30,30,0,0,1-1.411-3.575c-1.1-3.045-2.58-7.263-4.192-11.93l-2.255-6.587c-.689-2.022-1.23-3.894-2.256-5.109a4.114,4.114,0,0,0-3.2-1.6,4.024,4.024,0,0,0-1.326.319c-.007-.011.088-.095.3-.212a2.616,2.616,0,0,1,1.017-.289,4.227,4.227,0,0,1,3.457,1.567c1.12,1.265,1.7,3.184,2.41,5.181.706,2.029,1.479,4.247,2.289,6.574,1.612,4.668,3.047,8.9,4.063,11.975.518,1.534.876,2.8,1.264,3.6S147.794,235.756,147.761,235.783Z",
    transform: "translate(-132.272 -205.663)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4601",
    "data-name": "Group 4601",
    transform: "translate(0 30.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M146.67,239.9a3.2,3.2,0,0,1-.741.467c-.49.276-1.209.652-2.108,1.1-1.8.9-4.316,2.061-7.154,3.214s-5.456,2.072-7.368,2.68c-.956.3-1.734.536-2.277.68a3.21,3.21,0,0,1-.856.181,25.779,25.779,0,0,1,3.026-1.172c1.881-.686,4.471-1.652,7.3-2.8s5.359-2.261,7.187-3.079A26.035,26.035,0,0,1,146.67,239.9Z",
    transform: "translate(-126.168 -239.891)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4602",
    "data-name": "Group 4602",
    transform: "translate(1.647 33.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M129.632,247.614a10.265,10.265,0,0,1-1.584-4.042,10.279,10.279,0,0,1,1.584,4.042Z",
    transform: "translate(-128.019 -243.57)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4603",
    "data-name": "Group 4603",
    transform: "translate(5.947 32.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M134.3,245.844c-.109.061-.65-.726-1.041-1.827a3.815,3.815,0,0,1-.35-2.076,22.43,22.43,0,0,1,1.39,3.9Z",
    transform: "translate(-132.855 -241.941)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4604",
    "data-name": "Group 4604",
    transform: "translate(10.187 30.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M139.161,243.719a6.068,6.068,0,0,1-1.486-4.028,32.568,32.568,0,0,1,1.486,4.028Z",
    transform: "translate(-137.622 -239.69)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4605",
    "data-name": "Group 4605",
    transform: "translate(14.991 28.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M144.394,241.58a10.97,10.97,0,0,1-1.333-4.285,10.983,10.983,0,0,1,1.333,4.285Z",
    transform: "translate(-143.024 -237.295)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4611",
    "data-name": "Group 4611",
    transform: "translate(49.269 36.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4607",
    "data-name": "Group 4607",
    transform: "translate(0 2.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M192.528,244.559a68.7,68.7,0,0,1-7.533,2.658,68.681,68.681,0,0,1-7.676,2.214,68.736,68.736,0,0,1,7.535-2.658A68.663,68.663,0,0,1,192.528,244.559Z",
    transform: "translate(-177.319 -244.549)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4608",
    "data-name": "Group 4608",
    transform: "translate(1.934 2.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M180.848,247.723c-.118.051-.509-.607-.874-1.467s-.566-1.6-.447-1.651.509.607.873,1.468S180.966,247.673,180.848,247.723Z",
    transform: "translate(-179.493 -244.602)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4609",
    "data-name": "Group 4609",
    transform: "translate(6.034 1.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M185.188,246.678c-.117.048-.538-.73-.822-1.777a3.55,3.55,0,0,1-.193-1.949c.129-.021.361.81.639,1.827A5.275,5.275,0,0,1,185.188,246.678Z",
    transform: "translate(-184.104 -242.952)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4610",
    "data-name": "Group 4610",
    transform: "translate(10.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M189.846,245.186a8.321,8.321,0,0,1-.775-3.821,8.328,8.328,0,0,1,.775,3.821Z",
    transform: "translate(-189.009 -241.364)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4612",
    "data-name": "Group 4612",
    transform: "translate(19.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M144.2,203.186c-.128-.01-.2-.505-.155-1.108s.181-1.085.308-1.076.2.505.155,1.108S144.324,203.195,144.2,203.186Z",
    transform: "translate(-144.03 -201.001)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4613",
    "data-name": "Group 4613",
    transform: "translate(23.608 0.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M148.743,203.449c-.128.005-.251-.479-.275-1.082s.06-1.1.188-1.1.251.48.275,1.083S148.871,203.445,148.743,203.449Z",
    transform: "translate(-148.464 -201.266)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4614",
    "data-name": "Group 4614",
    transform: "translate(26.799 0.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M152.275,204.05c-.128,0-.228-.508-.223-1.133s.113-1.13.241-1.129.228.508.222,1.133S152.4,204.051,152.275,204.05Z",
    transform: "translate(-152.052 -201.788)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4615",
    "data-name": "Group 4615",
    transform: "translate(30.858 0.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M157.015,204.528c-.12.032-.374-.548-.4-1.315s.194-1.363.317-1.338.123.613.147,1.323S157.142,204.5,157.015,204.528Z",
    transform: "translate(-156.617 -201.874)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4616",
    "data-name": "Group 4616",
    transform: "translate(34.307 0.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M160.931,204.528c-.127.015-.3-.566-.388-1.3s-.054-1.338.073-1.354.3.566.387,1.3S161.058,204.513,160.931,204.528Z",
    transform: "translate(-160.494 -201.876)",
    fill: "#263238"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.707ad61acbd255cfb0a5d28af70c898c.svg";
export { ForwardRef as ReactComponent };